<template>
    <div class="canvas-animation" v-bind:class="{hide: !isCanvasVisible, home: isHome}">
    </div>
</template>

<script>
import store from '../store/store';
export default {
  name: 'canvas-animation',
  computed: {
    isCanvasVisible: () => {
        return store.state.isCanvasVisible;
    },
    isHome: function() {
        return this.$route.name === 'home'
    }
  },
  data () {
    return {
    }
  },
  mounted() {
    this.$store.commit('INIT_CANVAS_PLAYER', {
      domEl: document.querySelector('.canvas-animation'),
    });
    const link = '/static/animation/anim.json';
    // this.$store.commit('LOAD_ANIMATION', {
    //     link: link,
    //     cb: () => {
    //         this.$store.commit('INIT_CANVAS_PLAYER', {
    //             domEl: document.querySelector('.canvas-animation'),
    //         });
    //     }
    // })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Canvas.vue?154d5862